export const hallOfFameTranslations = {
  fr: {
    title: "Hall of Fame",
    subtitle: "Les légendes de la communauté médicale",
    activeMembers: "Membres actifs",
    badgesWon: "Badges gagnés",
    flashcardsReviewed: "Flashcards révisées",
    challengesCompleted: "Challenges complétés",
    yourRank: "Vous êtes classé <strong>#{{rank}}</strong> sur {{total}} membres !",
    monthLegends: "Légendes du Mois",
    excellenceCategories: "Catégories d'Excellence",
    fullLeaderboard: "Classement Complet",
    cards: "cartes",
    days: "jours",
    reputation: "réputation",
    challenges: "challenges",
    badges: "badges",
    medicine: "Médecine",
    pts: "pts",
    loading: "Chargement",
    loadingPodium: "Chargement du podium",
    loadingLeaderboard: "Chargement du classement",
    globalStats: "Statistiques globales",
    monthPodium: "Podium du mois",
    excellenceCategoriesLabel: "Catégories d'excellence",
    fullLeaderboardLabel: "Classement complet",
    rank: "Rang {{rank}}",
    categories: {
      quizMaster: "Quiz Master",
      flashcardChampion: "Flashcard Champion",
      streakLegend: "Streak Legend",
      badgeCollector: "Badge Collector",
      challengeChampion: "Challenge Champion",
      communityLeader: "Community Leader",
    },
    records: {
      highestQuizScore: "Plus haut score quiz",
      longestStreak: "Plus long streak",
      challengeChampion: "Champion challenges",
      completed: "complétés",
    },
  },
  en: {
    title: "Hall of Fame",
    subtitle: "The legends of the medical community",
    activeMembers: "Active members",
    badgesWon: "Badges won",
    flashcardsReviewed: "Flashcards reviewed",
    challengesCompleted: "Challenges completed",
    yourRank: "You are ranked <strong>#{{rank}}</strong> out of {{total}} members!",
    monthLegends: "Legends of the Month",
    excellenceCategories: "Categories of Excellence",
    fullLeaderboard: "Full Leaderboard",
    cards: "cards",
    days: "days",
    reputation: "reputation",
    challenges: "challenges",
    badges: "badges",
    medicine: "Medicine",
    pts: "pts",
    loading: "Loading",
    loadingPodium: "Loading podium",
    loadingLeaderboard: "Loading leaderboard",
    globalStats: "Global statistics",
    monthPodium: "Podium of the month",
    excellenceCategoriesLabel: "Categories of excellence",
    fullLeaderboardLabel: "Full leaderboard",
    rank: "Rank {{rank}}",
    categories: {
      quizMaster: "Quiz Master",
      flashcardChampion: "Flashcard Champion",
      streakLegend: "Streak Legend",
      badgeCollector: "Badge Collector",
      challengeChampion: "Challenge Champion",
      communityLeader: "Community Leader",
    },
    records: {
      highestQuizScore: "Highest quiz score",
      longestStreak: "Longest streak",
      challengeChampion: "Challenge champion",
      completed: "completed",
    },
  },
  es: {
    title: "Hall of Fame",
    subtitle: "Las leyendas de la comunidad médica",
    activeMembers: "Miembros activos",
    badgesWon: "Insignias ganadas",
    flashcardsReviewed: "Tarjetas revisadas",
    challengesCompleted: "Desafíos completados",
    yourRank: "Estás clasificado <strong>#{{rank}}</strong> de {{total}} miembros!",
    monthLegends: "Leyendas del Mes",
    excellenceCategories: "Categorías de Excelencia",
    fullLeaderboard: "Clasificación Completa",
    cards: "tarjetas",
    days: "días",
    reputation: "reputación",
    challenges: "desafíos",
    badges: "insignias",
    medicine: "Medicina",
    pts: "pts",
    loading: "Cargando",
    loadingPodium: "Cargando podio",
    loadingLeaderboard: "Cargando clasificación",
    globalStats: "Estadísticas globales",
    monthPodium: "Podio del mes",
    excellenceCategoriesLabel: "Categorías de excelencia",
    fullLeaderboardLabel: "Clasificación completa",
    rank: "Puesto {{rank}}",
    categories: {
      quizMaster: "Quiz Master",
      flashcardChampion: "Flashcard Champion",
      streakLegend: "Streak Legend",
      badgeCollector: "Badge Collector",
      challengeChampion: "Challenge Champion",
      communityLeader: "Community Leader",
    },
    records: {
      highestQuizScore: "Puntuación más alta en quiz",
      longestStreak: "Racha más larga",
      challengeChampion: "Campeón de desafíos",
      completed: "completados",
    },
  },
};
